module.exports = __webpack_public_path__ + "2a58095.woff";